module.exports = __webpack_public_path__ + "79f319b7612f0deed6fbf93c96edfe19.jpg";